module.exports = __webpack_public_path__ + "static/colors-content-hierarchy-do-134c09940191498f6221e750628b33a0.png";